var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEyeOpenSvgrepoCom(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.127,
    height: 18.181,
    viewBox: "0 0 30.127 18.181",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "eye-open-svgrepo-com",
    transform: "translate(0 -11.946)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_53138",
    "data-name": "Group 53138",
    transform: "translate(0 11.946)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_53135",
    "data-name": "Group 53135"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_71824",
    "data-name": "Path 71824",
    d: "M14.5,30.127C6.266,30.127.336,21.612.087,21.25a.5.5,0,0,1,.019-.592c.28-.356,6.953-8.712,14.956-8.712,8.976,0,14.737,8.384,14.978,8.741a.5.5,0,0,1,0,.564c-.237.344-5.921,8.409-14.949,8.86C14.893,30.121,14.7,30.127,14.5,30.127Zm-13.37-9.14C2.3,22.536,7.91,29.47,15.039,29.114c7.618-.38,12.881-6.726,13.969-8.15-1.087-1.456-6.405-8.017-13.944-8.017C8.35,12.946,2.385,19.515,1.133,20.987Z",
    transform: "translate(0 -11.946)",
    fill: "#959595"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_53136",
    "data-name": "Group 53136",
    transform: "translate(11.571 5.598)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_71825",
    "data-name": "Path 71825",
    d: "M26.634,30.128a3.493,3.493,0,1,1,3.493-3.493A3.5,3.5,0,0,1,26.634,30.128Z",
    transform: "translate(-23.141 -23.143)",
    fill: "#959595"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_53137",
    "data-name": "Group 53137",
    transform: "translate(8.821 2.848)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_71826",
    "data-name": "Path 71826",
    d: "M23.884,30.128a6.243,6.243,0,1,1,6.243-6.243A6.25,6.25,0,0,1,23.884,30.128Zm0-11.486a5.243,5.243,0,1,0,5.243,5.243A5.249,5.249,0,0,0,23.884,18.642Z",
    transform: "translate(-17.641 -17.643)",
    fill: "#959595"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOpenSvgrepoCom);
export default __webpack_public_path__ + "static/media/eye-open-svgrepo-com.cb8337baf8462b0909a182246937d7d6.svg";
export { ForwardRef as ReactComponent };